import { SEAT_SELECTION_TYPE } from '../constants/travel-reservation.enum';

export interface TravelReservation_Arrival {
  disembarkGate?: {
    name: string;
  };
  disembarkTerminal?: {
    name: string;
  };
  arrivalStatus?: string;
  scheduledArrivalLocalDateTime: string;
  estimatedArrivalLocalDateTime: string;
  scheduledArrivalUtcDateTime?: string;
  estimatedArrivalUtcDateTime?: string;
  station: TravelReservation_Transport_Station;
}

export interface TravelReservation_Origin {
  boardingGate?: {
    name: string;
  };
  boardingTerminal?: {
    name: string;
  };
  departureStatus?: string;
  scheduledDepartureLocalDateTime: string;
  estimatedDepartureLocalDateTime: string;
  scheduledDepartureUtcDateTime?: string;
  estimatedDepartureUtcDateTime?: string;
  station: TravelReservation_Transport_Station;
}

export interface TravelReservation_Transport_Station {
  code: string;
  name: string;
  postalAddress: {
    cityName: string;
    countrySubdivision: {
      code: string;
    };
    country?: {
      code: string;
    };
  };
}

export interface TravelReservation_Reservation_BookingRef {
  id: string;
  organization: {
    id: string;
  };
}

export interface TravelReservation_Carrier {
  code: string;
  name: string;
}

export interface TravelReservation_TransportEquipment {
  transportType: string;
  code: string;
  name: string;
  subfleetCode?: string;
}

export interface AmenityCode {
  code: string;
}

export interface DatedMarketingSegment {
  operationalSuffix: string;
  flightNum: string;
  fareBasisCode?: string;
  carrier: TravelReservation_Carrier[];
}

export interface OperationalStatus {
  type?: string;
  subType?: string;
  flightNumChange?: boolean;
  rebookEligible?: boolean;
}

export interface TravelReservation_Leg_CabinClass {
  code: string;
  productCode: string;
  amenities: AmenityCode[];
  productAttributes?: ProductAttribute[];
  name?: string;
}

export interface ProductAttribute {
  code: string;
  subCode: string;
  name: string;
  inclusion: boolean;
}

export interface TravelReservation_Segment_Leg {
  legId: number;
  ordinal: number;
  carrier: TravelReservation_Carrier[];
  operationalSuffix: string;
  flightNum: string;
  transportOrigin: TravelReservation_Origin;
  transportDestination: TravelReservation_Arrival;
  transportEquipment: TravelReservation_TransportEquipment;
  onAirDuration: string;
  onGroundDuration: string;
  status: string;
  cabinClass: TravelReservation_Leg_CabinClass;
  international: boolean;
  seatSelectionType: SEAT_SELECTION_TYPE;
  sameDayArrival: boolean;
  onAirTime?: string;
  onGroundTime?: string;
  distanceMiles?: number;
}

export interface TravelReservation_Reservation_ReceiptDetails {
  currencyCode: string;
  priceMoney: string;
  paymentDueDt: string;
}

export interface Errors {
  code: string;
  message: string;
  moreInfo?: {
    developerMessage?: string;
  }[];
  developerMessage?: {
    developerMessage?: string;
  };
  category?: string;
}
